import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ServiceContactForm from '../components/ServiceContactForm';
import ProjectContactForm from '../components/ProjectContactForm';
import SEO from '../components/SEO';

const TEAM_MEMBERS = [
  {
    name: 'Christian Pabst',
    role: 'Indehaver',
    phone: '2168 4422',
    email: 'kontakt@pabstteknik.dk',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=85,format=auto/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-dji-0865-1-52-11zon.webp'
  },
  {
    name: 'Tom Henriksen',
    role: 'Servicemontør / Montør',
    phone: '2428 3874',
    email: 'tom@pabstteknik.dk',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=85,format=auto/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-dji-0863-1-51-11zon.webp'
  },
  {
    name: 'Poul Clausen',
    role: 'Servicemontør / Montør',
    phone: '3091 9831',
    email: 'poul@pabstteknik.dk',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=85,format=auto/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-dji-0859-1-49-11zon.webp'
  },
  {
    name: 'Jesper Thomsen',
    role: 'Servicetekniker',
    phone: '2677 7084',
    email: 'jesper@pabstteknik.dk',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=85,format=auto/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-dji-0861-1-50-11zon.webp'
  },
  {
    name: 'Jakob Riis',
    role: 'Servicemontør / Montør',
    phone: '2671 6622',
    email: 'jakob@pabstteknik.dk',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=85,format=auto/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-dji-0866-1-53-11zon.webp'
  },
  {
    name: 'Levi Wieland Plaetner',
    role: 'Servicetekniker',
    phone: '2629 4941',
    email: 'levi@pabstteknik.dk',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=85,format=auto/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-placeholder-02-80-11zon.webp'
  },
  {
    name: 'Hanne Dich Pedersen',
    role: 'Kontorassistent',
    phone: '2757 7215',
    email: 'hanne@pabstteknik.dk',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=85,format=auto/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-placeholder-02-80-11zon.webp'
  }
];

const TESTIMONIALS = [
  {
    quote: 'Det var nemt da holdet fra pabstteknik valgte at tage projektet. De var alle venlige og de fik mig til at føle mig tryg. Det endelige resultat endte med at blive bedre, end jeg kunne have forestillet mig!',
    author: 'Eva Sørensen',
    role: 'Produkt Designer'
  },
  {
    quote: 'Det klart bedste hold, jeg nogensinde har arbejdet med. De forstod virkelig opgaven og klarede det på rekord tid! Jeg vil varmt anbefale dem som virksomhed, du finder simpelthen ikke noget bedre team!',
    author: 'Bjarne Hansen',
    role: 'Afdelingsleder'
  },
  {
    quote: 'Pabst teknik er langt det bedste port firma derude! Jeg kunne bogstaveligt talt ikke være mere glad for, at jeg valgte at købe porte hos dem og fremragende service!',
    author: 'Lars Hansen',
    role: 'Produktionsleder'
  },
  {
    quote: 'Jeg var rystet da vi fik en skade på vores nye garage port, men da jeg ringede var de rolige og venlige og sendte en ud med det samme. Tak for en fantastisk venlig hjælp og hurtig udrykning!',
    author: 'Rikke Andersen',
    role: 'Salgselev'
  }
];

export default function ContactPage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % TESTIMONIALS.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <div className="bg-brand-bg">
      <SEO
        title="Kontakt Pabst Teknik ApS – Portservice i Vejen"
        description="Kontakt Pabst Teknik ApS i Vejen for rådgivning, akut portservice eller et uforpligtende tilbud på nye porte og Ajax sikring. Ring direkte på 21 68 44 22."
        url="/kontakt"
        keywords="kontakt Pabst Teknik, portservice kontakt, montør Vejen, Christiansfeld, telefon 21684422, Gestenvej 29 Vejen"
      />
      {/* Page Header */}
      <section className="relative bg-gradient-to-br from-slate-950 via-brand-dark to-brand-accent/20 text-white px-6 py-20 md:py-28 overflow-hidden">
        {/* Background Image with Blend Mode */}
        <div className="absolute inset-0 opacity-15 mix-blend-overlay">
          <img
            src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-house-scaled-66-11zon.webp"
            alt="Pabst Teknik ApS kontakt og kundeservice i Vejen"
            className="h-full w-full object-cover"
          />
        </div>
        
        {/* Subtle Tech Grid Overlay */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(2,132,199,0.08)_1px,transparent_1px),linear-gradient(to_bottom,rgba(2,132,199,0.08)_1px,transparent_1px)] bg-[size:3rem_3rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
        
        {/* Glowing Ambient Light */}
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-accent/20 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-slate-900/30 rounded-full blur-3xl pointer-events-none" />

        <div className="mx-auto max-w-7xl relative z-10 flex flex-col gap-5 items-center text-center">
          {/* Breadcrumb Navigation */}
          <nav aria-label="Brødkrummesti" className="flex items-center gap-2 text-xs sm:text-sm font-medium text-slate-300">
            <Link to="/" className="hover:text-white transition-colors flex items-center gap-1.5">
              <i className="fa-solid fa-house text-xs text-brand-accent" />
              <span>Forside</span>
            </Link>
            <i className="fa-solid fa-chevron-right text-[10px] text-slate-400" />
            <span className="text-brand-accent font-semibold" aria-current="page">Kontakt</span>
          </nav>

          {/* Floating Badge */}
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-brand-accent/10 text-brand-accent border border-brand-accent/20 uppercase tracking-widest">
            <i className="fa-solid fa-phone text-[10px] animate-pulse" /> Direkte support & rådgivning
          </span>

          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white font-display">
            Kontakt <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-slate-100 to-brand-accent">Pabst Teknik</span>
          </h1>
          
          <p className="text-base sm:text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed font-sans">
            Hos <Link to="/" className="text-white hover:text-brand-accent underline decoration-brand-accent/50 underline-offset-2 transition-colors font-medium">Pabst Teknik</Link> sidder vi altid klar til at rådgive dig. Vælg den formular der matcher dit behov bedst nedenfor – eller ring direkte til os på <a href="tel:+4521684422" className="text-white font-bold hover:underline underline-offset-4 decoration-brand-accent">+45 21 68 44 22</a>.
          </p>
        </div>
      </section>

      {/* 50/50 Opdelte Kontaktformularer */}
      <section className="relative z-20 px-4 sm:px-6 -mt-10 md:-mt-14 pb-16 lg:pb-24">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-stretch">
            {/* VENSTRE SIDE: Service & Reparation Formular */}
            <div className="flex flex-col h-full">
              <ServiceContactForm />
            </div>

            {/* HØJRE SIDE: Projekt & Nyt Tilbud med Mål & Billed-upload */}
            <div className="flex flex-col h-full">
              <ProjectContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* Virksomhedsoplysninger & Hurtigkontakt Bar */}
      <section className="px-6 py-12 md:py-16 bg-white border-t border-slate-100">
        <div className="mx-auto max-w-7xl">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="text-xs font-bold text-brand-accent uppercase tracking-widest">Virksomhedsoplysninger</span>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-brand-dark mt-1 font-display">
              Altid lige i nærheden
            </h2>
            <p className="text-slate-500 text-sm mt-2">
              Med base i Vejen kører vi ud til opgaver i hele Trekantområdet og Sydjylland (Vejen, Kolding, Christiansfeld, Fredericia, Vejle og Billund) samt det øvrige Jylland og Fyn med kort reaktionstid.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Telefon */}
            <div className="flex items-start gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-brand-accent/30 transition-all">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-sky-100 text-brand-accent">
                <i className="fa-solid fa-phone text-lg" />
              </span>
              <div>
                <h4 className="font-display text-sm font-bold text-brand-dark mb-0.5">Telefon</h4>
                <a href="tel:+4521684422" className="text-base font-bold text-slate-800 hover:text-brand-accent transition-colors block">
                  21 68 44 22
                </a>
                <p className="text-xs text-slate-400 mt-1">Alle hverdage 07:00 – 16:30</p>
              </div>
            </div>

            {/* E-mail */}
            <div className="flex items-start gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-brand-accent/30 transition-all">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-sky-100 text-brand-accent">
                <i className="fa-solid fa-envelope text-lg" />
              </span>
              <div className="min-w-0">
                <h4 className="font-display text-sm font-bold text-brand-dark mb-0.5">E-mail</h4>
                <a href="mailto:kontakt@pabstteknik.dk" className="text-sm font-bold text-slate-800 hover:text-brand-accent transition-colors truncate block">
                  kontakt@pabstteknik.dk
                </a>
                <p className="text-xs text-slate-400 mt-1">Svar inden for 24 timer</p>
              </div>
            </div>

            {/* Adresse */}
            <div className="flex items-start gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-brand-accent/30 transition-all">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-sky-100 text-brand-accent">
                <i className="fa-solid fa-location-dot text-lg" />
              </span>
              <div>
                <h4 className="font-display text-sm font-bold text-brand-dark mb-0.5">Adresse</h4>
                <p className="text-sm font-bold text-slate-800">Gestenvej 29</p>
                <p className="text-xs text-slate-500">6600 Vejen</p>
              </div>
            </div>

            {/* CVR & Dækning */}
            <div className="flex items-start gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-brand-accent/30 transition-all">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-sky-100 text-brand-accent">
                <i className="fa-solid fa-shield-halved text-lg" />
              </span>
              <div>
                <h4 className="font-display text-sm font-bold text-brand-dark mb-0.5">CVR & Sikring</h4>
                <p className="text-sm font-bold text-slate-800">CVR: 42228842</p>
                <p className="text-xs text-slate-500 mt-0.5">Dansk Portservice v. Pabst Teknik</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="px-6 pt-12 pb-20 md:pt-16 md:pb-28 bg-slate-50 border-t border-slate-100">
        <div className="mx-auto max-w-7xl">
          <div className="text-center max-w-3xl mx-auto mb-16 flex flex-col gap-4">
            <span className="text-xs font-bold text-brand-accent uppercase tracking-widest">Kontakt en medarbejder</span>
            <h2 className="text-3xl font-extrabold text-brand-dark sm:text-4xl font-display">
              Mød vores team
            </h2>
            <p className="text-slate-500 leading-relaxed">
              Har du haft besøg af en servicetekniker fra os som du kunne tænke dig at snakke med igen, så får du her muligheden for at kontakte den helt rigtige. Vi ønsker at du for den bedst mulige service fra Dansk port service ved pabstteknik.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {TEAM_MEMBERS.map((member) => (
              <div
                key={member.name}
                className="group flex flex-col rounded-2xl border border-slate-100 bg-white overflow-hidden shadow-sm transition-all hover:shadow-md"
              >
                <div className="relative aspect-[4/5] bg-slate-100 overflow-hidden">
                  <img
                    src={member.image}
                    alt={`Portræt af ${member.name}, ${member.role} hos Pabst Teknik ApS`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6 flex flex-col gap-4">
                  <div>
                    <h3 className="font-display text-lg font-bold text-brand-dark mb-0.5">{member.name}</h3>
                    <p className="text-xs font-semibold text-brand-accent uppercase tracking-wider">{member.role}</p>
                  </div>
                  <div className="flex flex-col gap-2 text-sm border-t border-slate-100 pt-4">
                    <div className="flex items-center gap-2.5 text-slate-600">
                      <i className="fa-regular fa-phone text-brand-accent" />
                      <a href={`tel:${member.phone.replace(/\s+/g, '')}`} className="hover:text-brand-accent transition-colors whitespace-nowrap">
                        {member.phone}
                      </a>
                    </div>
                    <div className="flex items-center gap-2.5 text-slate-600">
                      <i className="fa-regular fa-envelope text-brand-accent" />
                      <a href={`mailto:${member.email}`} className="hover:text-brand-accent transition-colors truncate">
                        {member.email}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Christian Pabst Quote */}
          <div className="mt-16 max-w-4xl mx-auto rounded-3xl bg-brand-dark text-white p-8 md:p-12 shadow-xl relative overflow-hidden">
            <div className="absolute top-6 right-8 text-white/5 text-8xl font-serif select-none">”</div>
            <div className="relative z-10 flex flex-col gap-6 text-center md:text-left">
              <p className="text-lg md:text-xl font-medium leading-relaxed italic text-slate-100">
                “Der er ikke en opgave der er umulig! Det er kun et spørgsmål om hvordan! Vi klarer alle opgaver inden for porte og ramper!”
              </p>
              <div className="flex flex-col md:flex-row items-center justify-between gap-4 border-t border-white/10 pt-6">
                <div>
                  <h4 className="font-display text-base font-bold text-white">Christian Pabst</h4>
                  <p className="text-xs text-slate-400">Direktør / Indehaver</p>
                </div>
                <a
                  href="tel:+4521684422"
                  className="rounded-full bg-brand-accent px-6 py-2.5 text-sm font-bold text-white shadow-md transition-all hover:bg-brand-accent-hover"
                >
                  Ring direkte til Christian
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="px-6 py-20 md:py-28 bg-white border-t border-slate-100">
        <div className="mx-auto max-w-7xl">
          <div className="text-center max-w-3xl mx-auto mb-16 flex flex-col gap-4">
            <span className="text-xs font-bold text-brand-accent uppercase tracking-widest">Kundeanmeldelser</span>
            <h2 className="text-3xl font-extrabold text-brand-dark sm:text-4xl font-display">
              Hvad vores kunder siger
            </h2>
            <p className="text-slate-500 leading-relaxed">
              Vi sætter en stor ære i at levere service i topklasse. Her er et udvalg af udtalelser fra vores glade kunder.
            </p>
          </div>

          <div
            className="max-w-4xl mx-auto relative"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <div className="rounded-3xl bg-slate-50 border border-slate-100 p-8 md:p-12 shadow-sm relative overflow-hidden">
              <div className="flex flex-col gap-6 text-center">
                <div className="flex justify-center gap-1 text-amber-400 text-lg">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star" />
                  ))}
                </div>
                <p className="text-lg md:text-xl font-medium text-slate-700 leading-relaxed italic">
                  "{TESTIMONIALS[currentSlide].quote}"
                </p>
                <div>
                  <h4 className="font-display text-base font-bold text-brand-dark">
                    {TESTIMONIALS[currentSlide].author}
                  </h4>
                  <p className="text-xs text-slate-400 font-semibold uppercase tracking-wider">
                    {TESTIMONIALS[currentSlide].role}
                  </p>
                </div>
              </div>
            </div>

            {/* Slide Navigation Dots */}
            <div className="flex justify-center gap-2 mt-6">
              {TESTIMONIALS.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentSlide(idx)}
                  className={`h-2.5 rounded-full transition-all ${
                    currentSlide === idx ? 'w-8 bg-brand-accent' : 'w-2.5 bg-slate-300'
                  }`}
                  aria-label={`Gå til udtalelse ${idx + 1}`}
                />
              ))}
            </div>
          </div>

          {/* Cross-linking to other pages */}
          <div className="mt-16 pt-12 border-t border-slate-200/80">
            <div className="text-center max-w-2xl mx-auto mb-8">
              <h3 className="text-xl font-bold text-brand-dark font-display">
                Vil du vide mere inden du kontakter os?
              </h3>
              <p className="text-xs sm:text-sm text-slate-500 mt-1">
                Læs om vores services, se eksempler på vores arbejde eller læs mere om Pabst Teknik ApS.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <Link
                to="/ydelser"
                className="group p-5 rounded-2xl bg-white border border-slate-100 shadow-xs hover:shadow-md hover:border-brand-accent/30 transition-all flex flex-col justify-between"
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent group-hover:bg-brand-accent group-hover:text-white transition-colors">
                    <i className="fa-solid fa-wrench text-sm" />
                  </span>
                  <h4 className="font-display text-sm font-bold text-brand-dark group-hover:text-brand-accent transition-colors">
                    Se Vores Ydelser
                  </h4>
                </div>
                <p className="text-xs text-slate-500 leading-relaxed mb-3">
                  Udforsk vores store udvalg af portservice, lovpligtigt eftersyn, porte og Ajax sikring.
                </p>
                <span className="text-xs font-bold text-brand-accent inline-flex items-center gap-1 group-hover:gap-1.5 transition-all">
                  Læs om ydelser <i className="fa-regular fa-arrow-right text-[10px]" />
                </span>
              </Link>

              <Link
                to="/om-os"
                className="group p-5 rounded-2xl bg-white border border-slate-100 shadow-xs hover:shadow-md hover:border-brand-accent/30 transition-all flex flex-col justify-between"
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent group-hover:bg-brand-accent group-hover:text-white transition-colors">
                    <i className="fa-solid fa-building-user text-sm" />
                  </span>
                  <h4 className="font-display text-sm font-bold text-brand-dark group-hover:text-brand-accent transition-colors">
                    Læs Om Pabst Teknik
                  </h4>
                </div>
                <p className="text-xs text-slate-500 leading-relaxed mb-3">
                  Lær mere om vores historie, værdier, kvalitetssikring og Lindab salgspartnerskab.
                </p>
                <span className="text-xs font-bold text-brand-accent inline-flex items-center gap-1 group-hover:gap-1.5 transition-all">
                  Om virksomheden <i className="fa-regular fa-arrow-right text-[10px]" />
                </span>
              </Link>

              <Link
                to="/galleri"
                className="group p-5 rounded-2xl bg-white border border-slate-100 shadow-xs hover:shadow-md hover:border-brand-accent/30 transition-all flex flex-col justify-between"
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent group-hover:bg-brand-accent group-hover:text-white transition-colors">
                    <i className="fa-solid fa-images text-sm" />
                  </span>
                  <h4 className="font-display text-sm font-bold text-brand-dark group-hover:text-brand-accent transition-colors">
                    Se Vores Galleri
                  </h4>
                </div>
                <p className="text-xs text-slate-500 leading-relaxed mb-3">
                  Gennemse billeder af udførte monteringer af industriporte, garageporte og sikring.
                </p>
                <span className="text-xs font-bold text-brand-accent inline-flex items-center gap-1 group-hover:gap-1.5 transition-all">
                  Se billeder <i className="fa-regular fa-arrow-right text-[10px]" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
